export default __webpack_public_path__ + "static/media/extra_out_r5.54bc8324.svg";